export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'loader',
	namespaced: true,
	state: {
		/**
		 * props
		 * name: string, the value contains [api method name].[api controller name] ex. get.customers
		 * value: boolean
		 */
		loader: []
	},
	mutations: {
		handleLoading(state, data) {
			if (data.value) {
				state.loader.push(data);
			} else {
				state.loader = state.loader.filter(
					load => load.name !== data.name
				);
			}
		}
	},
	actions: {
		show({ commit }, name) {
			commit('handleLoading', { name: name, value: true });
		},
		hide({ commit }, name) {
			commit('handleLoading', { name: name, value: false });
		}
	},
	getters: {
		loading: state => value => {
			if (Array.isArray(value)) {
				const exists = value.some(x =>
					state.loader.some(l => l.name.includes(x))
				);
				return exists;
			}

			return state.loader.some(x => x.name === value);
		}
	}
};
